module.exports = __webpack_public_path__ + "media/customizations/vistaatmontaine/logo-6a7c95faa9138f92ca26e3502ef9e829.png";